import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/aceocean/billoflading'
import pathMap from 'src/paths/pathMap'

class AceOcnBillofladingRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ACE_OCN_BILLOFLADING_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ACE_OCN_BILLOFLADING_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ACE_OCN_BILLOFLADING_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ACE_OCN_BILLOFLADING_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default AceOcnBillofladingRoute
